import { USERS_CREATE, USERS_EDIT, USERS_ERROR, USERS_FETCHING_DATA, USERS_INDEX, USERS_SHOW } from '../../typesAction';

const INITIAL_STATE = {
  users: [],
  currentUser: {},
  errorMessage: null,
  inProgress: false,
  totalItems: 0
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case USERS_INDEX:
      return {
        ...state,
        users: action.payload["hydra:member"],
        totalItems: action.payload["hydra:totalItems"],
        errorMessage: null,
        inProgress: false
      };
    case USERS_CREATE:
      return { ...state, errorMessage: null, inProgress: false };
    case USERS_SHOW:
      return { ...state, currentUser: action.payload, errorMessage: null, inProgress: false };
    case USERS_EDIT:
      return { ...state, errorMessage: null, inProgress: false };
    case USERS_ERROR:
      return { ...state, errorMessage: action.payload.response.data, inProgress: false };
    case USERS_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    default:
      return state;
  }
}
